export default __webpack_public_path__ + "static/media/grafema_f1rst_02.f93ef9df.mp4";